import { REGIONS } from 'shared/constants';

const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'content',
    label: 'Content'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'ENUM',
    key: 'region',
    label: 'Region',
    options: REGIONS
  },
  {
    type: 'STRING',
    key: 'last_updated',
    label: 'Last Updated',
  },
  {
    type: 'STRING',
    key: 'page_title',
    label: 'Page Title',
  }
];

export default {
  id: 'CenterText',
  name: 'Center Text',
  creator: 'FF Web',
  updatedBy: 'Claire Lin',
  createdAt: 1508459822000,
  updatedAt: 1508459822000,
  slots,
  templateSettings,
  defaultProps
};
